"use client";

import { MediaWorkspace } from "../_components/MediaWorkspace";
import { convertVideoOperation } from "../_operations/convertVideo";

export function ConvertVideoContent() {
  return <MediaWorkspace operation={convertVideoOperation} />;
}
